import Enllac from 'components/corporatiu/Enllac';
import clsx from 'clsx';
import styles from './menusecundari.module.scss';
import Image from 'next/image';
import Icona from 'components/corporatiu/ui/Icona';
import { dataResources } from 'utils/constants';

const imageLoader = ({ src }) => {
    return `${src}`;
};

const { basePath } = dataResources;

const contingutMenu = (seccio, opcio) => {
    switch (seccio) {
        case 'corporatiu':
            return (
                <>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'inici' })}
                        href='/corporatiu/ca/el-grup/'
                    >
                        <span>Coneix-nos</span>
                    </Enllac>
                    <Enllac className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'atencio' })} href='/atencio/'>
                        <span>Atenció a l&apos;audiència</span>
                    </Enllac>
                    <Enllac className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'premsa' })} href='/premsa/'>
                        <span>Premsa</span>
                    </Enllac>
                    <Enllac className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'marato' })} href='/tv3/marato/'>
                        <span>La Marató</span>
                    </Enllac>
                </>
            );
        case 'tv3':
            return (
                <>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'directes' })}
                        href='/corporatiu/ca/el-grup/'
                    >
                        Directes
                    </Enllac>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'programacio' })}
                        href='/atencio/'
                    >
                        Programació
                    </Enllac>
                    <Enllac className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'cataleg' })} href='/premsa/'>
                        Catàleg
                    </Enllac>
                    <Enllac className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'canals' })} href='/tv3/marato/'>
                        Canals
                    </Enllac>
                </>
            );
        case 'catradio':
            return (
                <>
                    <Enllac className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'directes' })} href='/atencio/'>
                        Directes
                    </Enllac>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'programacio' })}
                        href='/corporatiu/ca/el-grup/'
                    >
                        Programació
                    </Enllac>
                    <Enllac className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'emissores' })} href='/premsa/'>
                        Emissores
                    </Enllac>
                    <Enllac className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'cataleg' })} href='/tv3/marato/'>
                        Catàleg
                    </Enllac>
                </>
            );
    }
};

const titolSeccio = (seccio, opcio) => {
    switch (seccio) {
        case 'corporatiu':
            return (
                <Enllac href='/corporatiu/ca/el-grup/' title='Corporació 3Cat' className={styles.secundariTitol}>
                    Corporatiu
                </Enllac>
            );
        case 'tv3':
            return (
                <Enllac href='/tv3/' title='TV3' className={styles.secundariTitol}>
                    TV3
                </Enllac>
            );
        case 'catradio':
            return (
                <Enllac href='/catradio/' title='Catalunya Ràdio' className={styles.secundariTitol}>
                    Catalunya Ràdio
                </Enllac>
            );
    }
};

const peuSideMenu = () => {
    return (
        <div className={styles.peuMenu} aria-label='Enllaços peu del menú'>
            <div className={styles.peuLogo}>
                <Enllac href='/3cat/'>
                    <Image
                        loader={imageLoader}
                        unoptimized={true}
                        width={82}
                        height={24}
                        alt='Logo 3Cat'
                        src={basePath + '/_resources/logos/3cat_color.svg?v=2.2512.2'}
                    />
                </Enllac>
            </div>

            <div className={styles.peuMarques}>
                <Enllac href='/tv3/' className={styles.peuTv3}>
                    <div className={styles.logotv3}>
                        <Image
                            loader={imageLoader}
                            unoptimized={true}
                            width={32}
                            height={24}
                            alt='TV3'
                            src={basePath + '/_resources/logos/tv3_W.svg?v=2.2512.2'}
                        />
                    </div>
                </Enllac>
                <Enllac href='/catradio/' className={styles.peuCr}>
                    <Image
                        loader={imageLoader}
                        unoptimized={true}
                        width={32}
                        height={24}
                        alt='Catalunya Ràdio'
                        src={basePath + '/_resources/logos/cr_W.svg?v=2.2512.2'}
                    />
                </Enllac>
                <Enllac href='/3catinfo/' className={styles.peuInfo}>
                    <Image
                        loader={imageLoader}
                        unoptimized={true}
                        width={90}
                        height={18}
                        alt='3catinfo'
                        src={basePath + '/_resources/logos/3catinfo_W.svg?v=2.2512.2'}
                    />
                </Enllac>
                <Enllac href='/tv3/sx3/' className={styles.peuSx3}>
                    <Image
                        loader={imageLoader}
                        unoptimized={true}
                        width={40.74}
                        height={20}
                        alt='SX3'
                        src={basePath + '/_resources/logos/sx3_W.svg?v=2.2512.2'}
                    />
                </Enllac>
                <Enllac href='/3cat/eva/' className={styles.peuEva}>
                    <Image
                        src={basePath + '/_resources/logos/eva_W.svg?v=2.2512.2'}
                        loader={imageLoader}
                        unoptimized={true}
                        width={40.87}
                        height={18}
                        alt='EVA'
                    ></Image>
                </Enllac>
            </div>
            <div>
                <ul className={styles.peuAltres}>
                    <li className={styles.peuCorpo}>
                        <Enllac href='/corporatiu/ca/el-grup/'>Corporatiu</Enllac>
                    </li>
                    <li>
                        <Enllac href='https://botiga.3cat.cat/'>Botiga</Enllac>
                    </li>
                    <li>
                        <Enllac href='/cercador/?profile=portalunic' className={styles.peuCerca}>
                            Cerca
                            <Icona className={styles.ico_cerca} icona='cercador' alt='' isBlanc={true} mida={18} />
                        </Enllac>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export { contingutMenu, titolSeccio, peuSideMenu };
